<!-- {{stateService.currentPatientId$ | async}} -->
<mat-card style="width: max-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Tasks
                </mat-card-title>
                <mat-card-subtitle>
                    Active tasks for patient care and management
                </mat-card-subtitle>
            </div>

            <div class="right gap-10 g-just-flex" style="flex-wrap: wrap;">
                @if(false){
                @if(canExport$ | async) {
                <a mat-flat-button class="secondary-button small-button">
                    <mat-icon>file_upload</mat-icon> Import
                </a>
                }
                @if (canExport$ | async) {
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>
                }
            }
                @if (canAdd$ | async) {
                <a mat-flat-button class="" (click)="addTask()">
                    <mat-icon>add</mat-icon>
                    Add Task
                </a>
                }
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <!-- @if(tableDataSource.data && tableDataSource.data.length > 0){
        <mat-divider></mat-divider>
        @if(tableHeaderMappedFilterArray && tableHeaderMappedFilterArray.size || 0 > 0 ) {
        <app-table-header [patientsTableFilterArray]="tableHeaderMappedFilterArray!"
            [patientsFiltersFormControlObject]="tableHeaderFiltersFormControlObject">
        </app-table-header>
        }} -->

        <div style="background-color: var(--mat-sys-surface-variant);
        width: max-content; max-width: 100%; overflow-x: auto;
        border-radius: 16px; margin-top: 15px; margin-bottom: 10px;" class="g-just-flex">
            @for (tab of tabs; track tab; let idx = $index) {
            <button
                style="padding: 9px 12px; border-radius: 16px; font-size: 13px; border: none;
        display: block; max-width: 200px; overflow: hidden; text-overflow: ellipsis; font-family: inherit; cursor: pointer;"
                [style.background-color]="activeTabIndex !== idx ? 'var(--mat-sys-surface-variant)' : 'var(--mat-sys-primary)'"
                [style.color]="activeTabIndex !== idx ? 'var(--mat-sys-on-surface)' : 'var(--mat-sys-on-primary)'"
                (click)="onCustomTabChange(idx)">
                {{ tab | titlecase }}
            </button>
            }
        </div>

        <div class="py-15 w-100 g-just-flex " style="flex-wrap: wrap;
        margin: auto; width: 100%;
      
        ">
            <!-- <div style="  background-color: var(--mat-sys-surface-variant);
        width: max-content; max-width: 100%; overflow-x: auto;
        border-radius: 16px;
        " class="g-just-flex">
                @for (additionalFilter of additionalFilters; track additionalFilter) { <button style="padding: 9px 12px; border-radius: 16px; font-size: 13px; border: none;
        display: block; max-width: 200px; overflow: hidden; text-overflow: ellipsis; font-family: inherit; cursor: pointer;
        " [style.background-color]="currentFilter !== additionalFilter ? 'var(--mat-sys-surface-variant)' : 'var(--mat-sys-primary)'"
                    [style.color]="currentFilter !== additionalFilter ? 'var(--mat-sys-on-surface)' : 'var(--mat-sys-on-primary)'"
                    (click)="applyAdditionalFilter(additionalFilter)">
                    {{ additionalFilter | titlecase }}
                </button>
                }
            </div> -->
        </div>
        @if(tableDataSource.data && tableDataSource.data.length > 0){
        <!-- {{tableDataSource.data | json}} -->
        <table mat-table matSort [dataSource]="tableDataSource.data"
            class="mat-elevation-z8 demo-table restricted-columns">


            <!-- Task Name Column -->
            <ng-container matColumnDef="taskName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="description"
                    sortActionDescription="Sort by Task Name">
                    Task Name
                </th>
                <td mat-cell *matCellDef="let element" [title]="element.taskName" #nameCell>
                    <div class="top pt-8">
                        <!-- {{element | json}} -->
                        {{element.taskName}}
                    </div>
                    <div class="bottom g-just-flex py-8"
                        style="justify-content: flex-start; gap: 6px; flex-wrap: wrap;">
                        @if(element['groupIdentifier']?.value) {
                        <span class="group-badge" [matMenuTriggerFor]="inlineGroupMenu"
                            matTooltip="Part of task group '{{ element['_groupValueString'] }}' ({{ element['_groupCount'] }} tasks)">
                            <mat-icon style="font-size:13px;width:13px;height:13px;">workspaces</mat-icon>
                            <!-- {{ (element['_groupValueString'] || element['groupIdentifier']?.value) | slice:0:18 }} -->
                            Group View
                            {{
                            (element['_groupValueString'] || element['groupIdentifier']?.value)?.length > 18 ? '…' : ''
                            }}
                            <span class="group-count">{{ element['_groupCount'] }}</span>
                        </span>
                        <mat-menu #inlineGroupMenu="matMenu">
                            <button mat-menu-item (click)="manageTaskGroup(element['groupIdentifier']?.value)">
                                <mat-icon>settings</mat-icon>
                                <span>Manage Group</span>
                            </button>
                            @if (element['_canCancelGroup']) {
                            <button mat-menu-item (click)="cancelTaskGroup(element['groupIdentifier']?.value)"
                                class="danger-item">
                                <mat-icon class="danger-icon">cancel</mat-icon>
                                <span class="danger-text">Cancel All in Group</span>
                            </button>
                            }
                        </mat-menu>
                        }
                        @if(element.priority) {
                        <span [appEmphasis]="element.priority">{{element.priority}}</span>
                        }
                        @if(element.overdue) {
                        <span [appEmphasis]="'overdue'">Overdue</span>
                        }
                    </div>
                </td>
            </ng-container>

            <!-- Patient Column -->
            <ng-container matColumnDef="patient">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Patient">
                    Patient
                </th>
                <td mat-cell *matCellDef="let element" #patientCell>
                    <!-- <div class="stacked-cell"> -->
                    @if(element.patientDetails) {
                    <div class="primary-line" [title]="element.patientDetails.name | patientName">
                        {{element.patientDetails.name | patientName}}
                    </div>
                    <div class="secondary-line" [title]="element.patientDetails.birthDate | patientAge:false">
                        {{element.patientDetails.birthDate | patientAge:false}} |
                        {{element.patientDetails.gender | titlecase}}
                    </div>
                    } @else {
                    <span class="text-muted">{{element.for?.display || 'N/A'}}</span>
                    }
                    <!-- </div> -->
                </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Status">
                    Status
                </th>
                <td mat-cell *matCellDef="let element" #statusCell>
                    <div [appChips]="element.status" [fontSize]="'14px'"></div>
                </td>
            </ng-container>

            <!-- Priority Column -->
            <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Priority">
                    Priority
                </th>
                <td mat-cell *matCellDef="let element" #priorityCell>
                    @if(element.priority) {
                    @if(element.priority) {
                    <span [appEmphasis]="element.priority">{{element.priority}}</span>
                    }
                    } @else {
                    <span class="text-muted">N/A</span>
                    }
                </td>
            </ng-container>

            <!-- Assigned To Column -->
            <ng-container matColumnDef="assignedTo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Assigned To">
                    Assigned To
                </th>
                <td mat-cell *matCellDef="let element" #assignedCell>
                    <!-- {{element.assignedTo}} -->
                    @if(element.owner) {
                    @if(element.owner.display) {
                    <span>{{element.owner.display}}</span>
                    } @else {
                    <div [appReferenceDisplay]="element.owner?.reference" [InstantfetchAndRepace]="true"></div>
                    }
                    } @else {
                    <span> N / A</span>
                    }
                </td>
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Start Date">
                    To Be Done Between
                </th>
                <td mat-cell *matCellDef="let element" #startDateCell style="max-width:300px; ">
                    <div class="g-just-flex gap-10 py-8"
                        style="max-width:300px; justify-content: flex-start; align-items: center;">
                        <div class="stacked-cell">
                            @if(element.restriction?.period?.start) {
                            <div class="primary-line" [title]="element.restriction.period.start | date:'MMM d, yyyy'">
                                {{element.restriction.period.start | date:'MMM d, yyyy'}}
                            </div>
                            <div class="secondary-line" [title]="element.restriction.period.start | date:'h:mm a'">
                                {{element.restriction.period.start | date:'h:mm a'}}
                            </div>
                            } @else {
                            <span class="text-muted">N/A</span>
                            }
                        </div>

                        @if(element.restriction?.period?.start
                        && element.restriction?.period?.end
                        ) {
                        <div class="g-just-flex align-items-center gap-10">
                            <div class="rounded-icon g-just-flex" style="width:21px; height:21px; border-radius:50%;
                            border: 1px solid var(--mat-sys-outline)
                            ">
                                <mat-icon style="font-size:14px; height:14px; width: 14px;">arrow_forward</mat-icon>
                            </div>
                            <div class="stacked-cell">
                                @if(element.restriction?.period?.end) {
                                <div class="primary-line" [title]="element.restriction.period.end | date:'MMM d, yyyy'">
                                    {{element.restriction.period.end | date:'MMM d, yyyy'}}
                                </div>
                                <div class="secondary-line" [title]="element.restriction.period.end | date:'h:mm a'">
                                    {{element.restriction.period.end | date:'h:mm a'}}
                                </div>
                                } @else {
                                <span class="text-muted">N/A</span>
                                }
                            </div>
                        </div>
                        }


                    </div>
                </td>
            </ng-container>

            <!-- Due Date Column -->
            <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Due Date">
                    Due Date
                </th>
                <td mat-cell *matCellDef="let element" #dueDateCell>
                    <div class="stacked-cell">
                        @if(element.dueDate) {
                        <div class="primary-line" [title]="element.dueDate | date:'MMM d, yyyy'">
                            {{element.dueDate | date:'MMM d, yyyy'}}
                        </div>
                        <div class="secondary-line" [title]="element.dueDate | date:'h:mm a'">
                            {{element.dueDate | date:'h:mm a'}}
                        </div>
                        } @else {
                        <span class="text-muted">No due date</span>
                        }
                    </div>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element" class="action-column" #actionCell>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        @if(element['_canFulfillTask']) {
                        <button mat-menu-item (click)="fulfillTask(element); $event.stopPropagation()">
                            <mat-icon>edit</mat-icon>
                            <span>Fulfill Task</span>
                        </button>
                        }
                        @if(element['_canCompleteTask']) {
                        <button mat-menu-item (click)="completeTask(element); $event.stopPropagation()">
                            <mat-icon>check_circle</mat-icon>
                            <span>Mark as Complete</span>
                        </button>
                        }
                        @if(element['_canViewTask']) {
                        <button mat-menu-item (click)="viewTaskDetails(element); $event.stopPropagation()">
                            <mat-icon>visibility</mat-icon>
                            <span>View Details</span>
                        </button>
                        }
                        @if(element['groupIdentifier']?.value) {
                        <mat-divider></mat-divider>
                        <button mat-menu-item
                            (click)="manageTaskGroup(element['groupIdentifier']?.value); $event.stopPropagation()">
                            <mat-icon>workspaces</mat-icon>
                            <span>Manage Group ({{ element['_groupCount'] }})</span>
                        </button>
                        @if (element['_canCancelGroup']) {
                        <button mat-menu-item
                            (click)="cancelTaskGroup(element['groupIdentifier']?.value); $event.stopPropagation()"
                            class="danger-item">
                            <mat-icon class="danger-icon">cancel</mat-icon>
                            <span class="danger-text">Cancel All in Group</span>
                        </button>
                        }
                        }
                        @if(element['_canCancelTask']) {
                        <mat-divider></mat-divider>
                        <button mat-menu-item
                            (click)="cancelTasksAndFocus([element]).subscribe(); $event.stopPropagation()"
                            class="danger-item">
                            <mat-icon class="danger-icon">cancel</mat-icon>
                            <span class="danger-text">Cancel Task</span>
                        </button>
                        }
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true">
            </tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of tasks"></mat-paginator>

        <!-- No Data State -->
        }@else{
        <app-empty-state [icon]="'TASK_ALT'"
            [subtitle]="'No active tasks found. Try adjusting your filters or add a new task.'" [title]="'No Tasks'">
        </app-empty-state>
        }

    </mat-card-content>
</mat-card>